import { Phone } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "../i18n";
import { WhatsAppLogo } from "./WhatsAppLogo";

export default function FloatingButtons() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-center gap-3">
      <a
        data-testid="floating-call-button"
        href={PHONE_TEL}
        aria-label="Call Singh Taxi"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-callope text-white shadow-[0_10px_30px_rgba(249,115,22,0.45)] transition-transform hover:scale-105"
      >
        <Phone className="h-6 w-6" fill="currentColor" />
      </a>
      <a
        data-testid="floating-whatsapp-button"
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Singh Taxi"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-wa text-white shadow-[0_10px_30px_rgba(37,211,102,0.5)] ring-4 ring-wa/25 transition-transform hover:scale-105"
      >
        <WhatsAppLogo className="h-6 w-6" />
      </a>
    </div>
  );
}
